import { Buffer } from "buffer";
import { getAnalytics } from "firebase/analytics";
import { initializeApp } from "firebase/app";
import React from "react";
import { createRoot } from "react-dom/client";

import App from "./App";
import { DATABASE_URL } from "./config";
import "./index.scss";
import reportWebVitals from "./reportWebVitals";

// required for @terra-money/terra.js and @keplr-wallet/wc-client
window.Buffer = Buffer || require("buffer").Buffer;

const firebaseConfig = {
  apiKey: "AIzaSyCQCsbhhBDYYrvmqtn3Dlp0WKumc_AsF2k",
  authDomain: "mintdao-app.firebaseapp.com",
  databaseURL: DATABASE_URL,
  projectId: "mintdao-app",
  storageBucket: "mintdao-app.appspot.com",
  messagingSenderId: "375955204530",
  appId: "1:375955204530:web:214e82eb12fd0a8791dcab",
  measurementId: "G-7CRL5NXM7F",
};
// Initialize Firebase
const app = initializeApp(firebaseConfig);
getAnalytics(app);

const container = document.getElementById("root");
const root = createRoot(container!);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
